import React, { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner, Container, Alert, Button } from "react-bootstrap";
import { getPaymentStatus } from "../../features/buyer/buyerSlice";

const PaymentStatusPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");
  // const sessionId = searchParams.get("session_id");
  // const status = searchParams.get("status"); // optional, if sent
  const statusFromURL = searchParams.get("status"); // Optional if passed from backend

  const isCancelPage = location.pathname === "/payment-cancel";

  // console.log("🟢 PaymentStatusPage Loaded");

  // console.log("🔍 Query Params:", {
  //   orderId,
  //   sessionId,
  //   status
  // });

  // console.log("PaymentStatusPage:", {
  //   orderId,
  //   sessionId,
  //   statusFromURL: status,
  // });

  const { paymentStatus, paymentLoading, paymentError } = useSelector(
    (state) => state.buyer
  );

  useEffect(() => {
    if (orderId && !isCancelPage) {
      dispatch(getPaymentStatus(orderId));
    }
  }, [dispatch, orderId, isCancelPage]);

  if (!orderId) {
    return (
      <Container className="py-5 text-center">
        <Alert variant="danger">
          Invalid or missing order ID. Please check your payment URL.
        </Alert>
      </Container>
    );
  }

  const renderStatusMessage = () => {
    if (isCancelPage) {
      return (
        <Alert variant="danger" className="mx-auto" style={{ maxWidth: "800px", textAlign: "center", display: "block" }}>
          <div className="fw-bold mb-3">Payment Cancelled</div>
          <ul style={{ listStylePosition: "inside", paddingLeft: 0, marginBottom: 0 }}>
            <li style={{ marginBottom: "0.75rem" }}>Your payment was cancelled or interrupted before completion.</li>
            <li style={{ marginBottom: "0.75rem" }}>No amount has been charged. You may attempt the payment again at any time.</li>
            <li>If the problem persists, feel free to contact support or your seller for assistance.</li>
          </ul>
        </Alert>
      );
    }

    if (paymentLoading) {
      return <Spinner animation="border" />;
    }

    if (
      paymentError ||
      statusFromURL === "failed" ||
      paymentStatus?.status === "failed"
    ) {
      return (
        <Alert variant="danger" className="mx-auto" style={{ maxWidth: "800px", textAlign: "center", display: "block" }}>
          <div className="fw-bold mb-3">Payment Failed</div>
          <ul style={{ listStylePosition: "inside", paddingLeft: 0, marginBottom: 0 }}>
            <li style={{ marginBottom: "0.75rem" }}>
              Unfortunately, we were unable to process your payment for order <strong>#{orderId}</strong>.
            </li>
            <li style={{ marginBottom: "0.75rem" }}>
              This could be due to insufficient funds, a declined transaction, or a temporary issue with your payment provider.
            </li>
            <li>
              Please try again or contact your bank/payment provider for more information.
            </li>
          </ul>
        </Alert>
      );
    }

    // Success Case
    return (
      <Alert variant="success" className="mx-auto" style={{ maxWidth: "800px", backgroundColor: "#d1e7dd", borderColor: "#badbcc", color: "#0f5132", textAlign: "center", display: "block" }}>
        <div className="fw-bold mb-3">Payment Successful</div>
        <ul style={{ listStylePosition: "inside", paddingLeft: 0, marginBottom: 0 }}>
          <li style={{ marginBottom: "0.75rem" }}>
            Thank you! Your payment for order <strong>#{orderId}</strong> has been successfully completed.
          </li>
          <li style={{ marginBottom: "0.75rem" }}>
            Your order has now been confirmed and is being processed. You will receive updates regarding shipping.
          </li>
          <li>
            Please ensure accurate shipping information is provided for smooth delivery coordination.
          </li>
        </ul>
      </Alert>
    );
  };

  const isPaymentSuccess =
    !isCancelPage &&
    !paymentError &&
    statusFromURL !== "failed" &&
    paymentStatus?.status !== "failed";

  return (
    <Container
      className="text-center py-5 align-items-center d-flex flex-column justify-content-center "
      style={{ minHeight: "90vh" }}
    >
      {renderStatusMessage()}

      {/* Notes Box (only when payment successful) */}
      {isPaymentSuccess && (
        <Alert
          variant="warning"
          className="mt-4 mx-auto"
          style={{ maxWidth: "800px", backgroundColor: "#fff3cd", borderColor: "#ffecb5", color: "#664d03", textAlign: "center", display: "block" }}
        >
          <div className="fw-bold mb-3">Important Note</div>
          <ul style={{ listStylePosition: "inside", paddingLeft: 0, marginBottom: 0 }}>
            <li style={{ marginBottom: "0.75rem" }}>
              The platform does <strong>not</strong> provide logistics or shipping services.
            </li>
            <li style={{ marginBottom: "0.75rem" }}>
              All delivery arrangements must be coordinated directly between the Buyer and Seller.
            </li>
            <li>
              Please ensure the shipping details form is completed accurately to avoid delays.
            </li>
          </ul>
        </Alert>
      )}

      <div
        className="d-flex justify-content-center"
        style={{ gap: 12, marginTop: 16 }}
      >

        <Button variant="primary" href="/dashboard">
          Go to Dashboard
        </Button>
      </div>
    </Container>
  );
};

export default PaymentStatusPage;
